import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  output,
  type InputSignal,
  type OutputEmitterRef,
  type Signal,
} from '@angular/core';
import { UiButtonComponent } from '../ui-button/ui-button.component';

@Component({
  selector: 'ui-error-state',
  imports: [UiButtonComponent],
  templateUrl: './ui-error-state.component.html',
  styleUrl: './ui-error-state.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiErrorStateComponent {
  public readonly title: InputSignal<string> = input<string>('Something went wrong');
  public readonly description: InputSignal<string | null> = input<string | null>(null);
  public readonly actionLabel: InputSignal<string | null> = input<string | null>(null);
  public readonly actionSelected: OutputEmitterRef<void> = output<void>();

  protected readonly hasDescription: Signal<boolean> = computed((): boolean => !!this.description());
  protected readonly hasAction: Signal<boolean> = computed((): boolean => !!this.actionLabel());

  protected handleActionSelected(): void {
    this.actionSelected.emit();
  }
}
